module.exports = __webpack_public_path__ + "media/images/up-0556bba80fe5f99d1f6c19e9920970ff.png";